
import { useFilter } from '../../../filter/hook'
import { useQuery } from 'react-query'
import dataAPI from '../../services/dataAPI'
import { getPrevFilter, getNextFilter } from '../../../filter/utils/prefetchFilters'

export default function useActivePowerCore() {

  const{filter} = useFilter()
  const prevFilter = getPrevFilter(filter);
  const nextFilter = getNextFilter(filter);

  const activePowerQuery = useQuery({
    queryKey: ['active-power', filter],
    queryFn: () => dataAPI.getActivePowerPointSingleCounter(filter)
})

  // Préchargement des données pour les fenêtres précédente et suivante
  useQuery({
    queryKey: ['active-power', prevFilter],
    queryFn: () => dataAPI.getActivePowerPointSingleCounter(prevFilter),
    enabled: !!filter.device_name,
    staleTime: 5 * 60 * 1000,
  });

  useQuery({
    queryKey: ['active-power', nextFilter],
    queryFn: () => dataAPI.getActivePowerPointSingleCounter(nextFilter),
    enabled: !!filter.device_name,
    staleTime: 5 * 60 * 1000,
  });

  
  return{
      
      filter,
      activePowerQuery : {
        data : activePowerQuery.data,
        isLoading : activePowerQuery.isLoading,
        isSuccess : activePowerQuery.isSuccess,
        isError : activePowerQuery.isError,
        error : activePowerQuery.error,
        refetch : activePowerQuery.refetch,
        isRefetching : activePowerQuery.isRefetching
      },
  }
}
